import { render } from "./Prestation.vue?vue&type=template&id=957afb14&scoped=true"
import script from "./Prestation.vue?vue&type=script&lang=js"
export * from "./Prestation.vue?vue&type=script&lang=js"

import "./Prestation.vue?vue&type=style&index=0&id=957afb14&scoped=true&lang=css"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-957afb14"]])

export default __exports__